import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, } from '@angular/forms';
import { Router } from '@angular/router';
import { BookingService, Listing, } from '@clooper/core';
import { faUsers, faChild, faCat, faBaby, faAngleDown, faAngleUp, faCalendar, faTimes } from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-modify-date-booking',
  templateUrl: './modify-date-booking.component.html',
  styleUrls: ['./modify-date-booking.component.scss']
})
export class ModifyDateBookingComponent implements OnInit {
  bookingId: any;
  showNext: boolean;

  icons = {
    caretDown: faAngleDown,
    caretUp: faAngleUp,
    users: faUsers,
    child: faChild,
    pet: faCat,
    infant: faBaby,
    calendar: faCalendar,
    cancel: faTimes,

  }


  occupant_types = [
    { name: 'adults', icon: faUsers, subText: '' },
    { name: 'children', icon: faChild, subText: '(2-17 years)' },
    { name: 'infants', icon: faBaby, subText: '(Under 2 years)' },
    { name: 'pets', icon: faCat, subText: '' },


  ]

  occupant_form_array: { [x: string]: FormControl; }[] = []
  form: FormGroup


  loading = false;
  checkIn: any;
  formSubs: Subscription;
  occupants: string = '';
  dateRange: Date[] = [];
  minDate: Date;
  totalDuration: number;
  dateData: any;


  constructor(
    public bsModalRef: BsModalRef,
    private router: Router,
    private fb: FormBuilder,
    public options: ModalOptions,
    private bookingService: BookingService,

  ) {
    this.bookingId = this.options?.initialState?.booking

    this.dateData = this.options?.initialState?.data
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());

    this.occupant_form_array = this.occupant_types.map(occupant_type => {
      return {
        [occupant_type.name + ""]: new FormControl(this.options.initialState?.edit ? this.dateData[occupant_type.name] : 0, []),
      }
    });
    let occupant_form = Object.assign({}, ...this.occupant_form_array);
    if (this.options.initialState?.edit) {

      const { checkIn, checkOut } = this.dateData
      const cIndate = new Date(checkIn);
      const checkInDate = String(cIndate.getTime());
      const cOutdate = new Date(checkOut);
      const checkOutDate = String(cOutdate.getTime());
      this.dateRange = [new Date(+(checkInDate as string) as number), new Date(+(checkOutDate as string) as number)]
      // console.log(this.dateRange)
      this.form = this.fb.group({
        occupants: new FormControl('', []),
        ...occupant_form,
        message: ['']
      })
      this.constructString()
    } else {
      this.form = this.fb.group({
        occupants: new FormControl('', []),
        ...occupant_form
      })
    }
    this.totalDuration = moment.duration(+this.dateRange[1]?.getTime() - +this.dateRange[0]?.getTime(), 'milliseconds').asDays()
    // console.log(this.totalDuration)


  }

  ngOnInit() {

  }



  getDate(event: any) {
    this.checkIn = event.value;
  }

  increment(name: string) {
    this.form.controls[name].setValue(+this.form.value[name] + 1)
    this.totalDuration = moment.duration(+this.dateRange[1]?.getTime() - +this.dateRange[0]?.getTime(), 'milliseconds').asDays()

    this.constructString()
  }

  decrement(name: string) {
    if (+this.form.value[name] > 0) {
      this.form.controls[name].setValue(+this.form.value[name] - 1)
      this.constructString()
    }
  }

  constructString() {

    let string = `${+this.form.value['adults'] ? this.form.value['adults'] + (this.form.value['adults'] > 1 ? " Adults," : " Adult,") : ''} ${+this.form.value['children'] ? this.form.value['children'] + (this.form.value['children'] > 1 ? " Children," : " Child,") : ''}  ${+this.form.value['infants'] ? this.form.value['infants'] + (this.form.value['infants'] > 1 ? " Infants," : " Infant,") : ''} ${+this.form.value['pets'] ? this.form.value['pets'] + (this.form.value['pets'] > 1 ? " Pets," : " Pet,") : ''}`
    // this.occupant_types.forEach(occupant => {
    //   string += `${this.form.value[occupant.name] ? this.form.value[occupant.name] + (this.form.value[occupant.name] > 1 ? occupant.name + 's,' :  occupant.name + 's,') : ''}`
    // });
    string = string.trim()
    if (string.charAt(string.length - 1) === ',') {
      let temp = string.split('')
      temp.splice(string.length - 1)
      string = temp.join("")
    }
    this.form.controls['occupants'].setValue(string)
    // this.occupants = string
  }

  getRange() {
    const checkin = this.dateRange[0].getTime()
    const checkout = this.dateRange[1].getTime()
    const diff = checkout - checkin
    this.totalDuration = moment.duration(+this.dateRange[1]?.getTime() - +this.dateRange[0]?.getTime(), 'milliseconds').asDays()

    return moment.duration(diff, 'milliseconds').humanize(true, { m: 30, d: 7, w: 4 })
  }

  onValueChange(event: any) {
    this.totalDuration = moment.duration(+event[1]?.getTime() - +event[0]?.getTime(), 'milliseconds').asDays()

  }

  onConfirm() {
    const { adults, children, pets, infants, message } = this.form.value
    const data = {
      id: this.bookingId,
      check_in: this.dateRange[0],
      check_out: this.dateRange[1],
      guests: { adults, children, pets, infants },
      message
    };
    this.loading = true;
    this.bookingService.modifyUserBooking(this.bookingId, data).subscribe(res => {
      //  console.log(res)
      if (res) {
        this.showNext = true
      } // window.location.reload()
    }).add(() => this.loading = false)
  }

}
